// src/services/RedemptionAdminService.js
import { ErrorHandlerCaller as EHC, DEFAULTS_HANDLERS } from "@/utils/errors";
import { HTTP, BACKEND_API_URL } from "@/utils/http-common";
import axios from "axios";
import store from "@/store";

export default {
  async list(params = {}) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/activity/redemptions`, { params })
        .then(r => resolve(r.data)) // ✅ on retourne tout: {count,next,previous,results}
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e); });
    });
  },

  async approve(id) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/activity/redemptions/${id}/approve`)
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e); });
    });
  },

  async reject(id, reason) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/activity/redemptions/${id}/reject`, { reason })
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e); });
    });
  },

  async markPaid(id, reference) {
    return new Promise((resolve, reject) => {
      HTTP.post(`/activity/redemptions/${id}/mark-paid`, { reference })
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e); });
    });
  },

  async stats(params = {}) {
    return new Promise((resolve, reject) => {
      HTTP.get(`/activity/redemptions/stats`, { params })
        .then(r => resolve(r.data))
        .catch(e => { new EHC(DEFAULTS_HANDLERS).intercept(e); reject(e); });
    });
  },

  async exportExcel(params = {}) {
    const path = `/activity/redemptions/export`;
    const queryParams = new URLSearchParams(params).toString();
    const url = queryParams ? `${path}?${queryParams}` : path;
    const token = store.state.app.user ? store.state.app.user.key : null;
    const headers = {};
    if (token) headers.authorization = "Token " + token;
    const response = await axios.get(BACKEND_API_URL + url, {
      responseType: "blob",
      headers,
    });
    return response.data;
  }
};
